var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`priceChanges ${_vm.getChangeColor}`},[_c('div',{staticClass:"change"},[_vm._v(_vm._s(_vm.formatChange))]),_c('font-awesome-icon',{attrs:{"icon":_vm.getChangeIcon}}),_c('div',{staticClass:"changePrct"},[_vm._v(_vm._s(_vm.formatChangePrct))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }